export const getTextColorOnBackgroundColor = (backgroundColor: string) => {
  const brightness = backgroundColor
    ? parseInt(backgroundColor.substring(1, 3), 16) * 0.299 +
      parseInt(backgroundColor.substring(3, 5), 16) * 0.587 +
      parseInt(backgroundColor.substring(5, 7), 16) * 0.114
    : 256
  return brightness >= 180 ? '#000000' : '#ffffff'
}
